// build 時由 tsup `define` 把 __CHANNEL__ 烙成字面值(見 tsup.config.ts / src/global.d.ts)。
// vitest 不走 tsup,未注入時 typeof 為 'undefined' → 視為 prod(fail-safe)。
const CHANNEL_BASE_URL: Record<string, string> = {
	prod: 'https://api.wport.me',
	dev: 'https://developers.wport.me/v2',
};

/** 讀取 build 時烙進的 channel;未定義(未走 tsup / 未注入)時回 'prod'。 */
export function currentChannel(): string {
	return typeof __CHANNEL__ === 'string' ? __CHANNEL__ : 'prod';
}

/** channel → 預設 API base;未知 channel 一律 fallback prod。 */
export function channelBaseUrl(channel: string): string {
	return CHANNEL_BASE_URL[channel] ?? CHANNEL_BASE_URL.prod;
}

/** 非 prod channel 回一行提示(給 stderr 用,含換行);prod 回 null。 */
export function channelBanner(): string | null {
	const channel = currentChannel();
	if (channel === 'prod') return null;
	return `[${channel}] targeting the dev backend\n`;
}
